import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import axiosInstance from "../../services/api";
import "datatables.net";
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css"
import "datatables.net-responsive-dt";
import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import { useMenu } from '../../context/MenuContext';
import Loader from '../Commons/Loader';
function HotelListing() {
    const tableRef = useRef(null);
    const menuArr = useMenu();
    const [hotelListingData, setHotelListingData] = useState([]); // Set initial state as an empty array
    const [loading, setLoading] = useState(true);
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('hotel/all-hotels.json'); // Make a GET request
            setHotelListingData(response.data.data || []); // Set the entire array of users
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setLoading(false);
          }
    };
    const menuArrNw = menuArr.menuArr;
    console.log(menuArrNw, "menuArrNw")
    const checkEditHotel = () => {
        return menuArrNw.some(menu =>
            menu.subMenus.some(subMenu => subMenu.id === "edit-hotel")
        );
    };
    const showEditHotel = checkEditHotel();

    useEffect(() => {
            fetchData();
    }, []);

    useEffect(() => {
        if (hotelListingData.length > 0) {
            let columns = [
                { title: "Hub Registration Id" },
                { title: "Hotel Name" },
                { title: "Hotel Group" },
                { title: "Hotel Sub Group" },
                { title: "Enabled" }
            ];

            if (showEditHotel) {
                columns.push({ title: "Operations" });
            }
            let columnDefs = [
                { targets: 1, responsivePriority: 1 } // Name - Always visible
            ];
            if (showEditHotel) {
                columnDefs.push({ targets: 5, responsivePriority: 5 }); // Operations - Always visible
            }else{
                columnDefs.push({ targets: 4, responsivePriority: 4 }); // Operations - Always 
            }
            const table = $(tableRef.current).DataTable({
                destroy: true,  // Destroy previous instance
                paging: true,    // Enable pagination
                searching: true, // Enable search
                lengthChange: true, // Enable show entries dropdown
                ordering: true,  // Enable sorting
                responsive: {
                   
                },
                columnDefs: columnDefs,
                columns: columns
            });

            return () => {
                table.destroy(); // Clean up DataTable instance on unmount
            };
        }
    }, [hotelListingData, showEditHotel]); // Run when `userListingData` changes

    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
   
    return (
        <>
        {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6 title-mob">
                            <h1 className="m-0">Hotel Listing</h1>
                            {showEditHotel && <Link className="btn btn-primary submit-btn" to="/add-hotel">Add Hotel</Link>}
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Hotel Listing</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                <table ref={tableRef} className={`display styled-table ${!showEditHotel ? "show-edit-hotel" : ""}`}>
                        <thead>
                            <tr>
                                <th>Hub Registration Id</th>
                                <th>Hotel Name</th>
                                <th>Hotel Group</th>
                                <th>Hotel Sub Group</th>
                                <th>Enabled</th>
                                {showEditHotel && (
                                    <th>Operations</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {hotelListingData.length > 0 && hotelListingData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.hubRegistrationId}</td>
                                    <td>{item.hotelName}</td>
                                    <td>{item.hotelGroupDisplayName}</td>
                                    <td>{item.hotelSubGroupDisplayName}</td>
                                    <td>{item.enabled ? "true" : "false"}</td>
                                    {showEditHotel && (
                                        <td>
                                            <Link to={`/edit-hotel/${item.id}`} className="edit">
                                                <i className="nav-icon fas fa-pencil-alt"></i>
                                            </Link>
                                        </td>
                                    )}
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>{/* /.container-fluid */}
            </section>
        </>
    );
}

export default HotelListing;
